import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-video-tutorial',
  templateUrl: './video-tutorial.component.html',
  styleUrls: ['./video-tutorial.component.css'],
})
export class VideoTutorialComponent {
  @Input() title: string = '';
  @Input() videoPath: string = '';
  @Input() videoPoster: string = '';
  @Input() buttonText: string = '';
  @Input() buttonLink: string = '';
  @Input() features: string[] = [];
  
  @Output() buttonClicked = new EventEmitter<void>(); 

  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;

  isPlaying: boolean = false;

  onButtonClick() {
    if (this.buttonLink) {
      window.open(this.buttonLink, '_blank'); 
    } else {
      this.buttonClicked.emit(); 
    }
  }

  playVideo() {
    if (this.videoPlayer && this.videoPlayer.nativeElement) {
      this.videoPlayer.nativeElement.play();
    }
  }

  onVideoPlay() { this.isPlaying = true; }
  onVideoPause() { this.isPlaying = false; }
  onVideoEnded() { this.isPlaying = false; }
}